<template>
  <gj-modal
    v-bind="$attrs"
    v-on="$listeners"
    :visible.sync="modalVisible"
    :destroyOnClose="true"
    :footer="false"
    size="auto"
  >
    <template #content>
      <div class="user-guide-succ-container">
        <div class="succ-modal-top">
          <img :src="require('@/assets/images/userGuide/succIcon.png')" class="succ-icon">
        </div>
        <div class="succ-modal-main flex flex-direction-column align-center">
          <div class="succ-modal-title">恭喜您已经完成【{{taskName}}】</div>
          <div class="succ-modal-integral flex align-center"><gj-icon iconfont="iconjidian" class="size22 gj-mr4"></gj-icon>+{{integral}}积点</div>
          <div class="succ-modal-tip">完成更多任务，可以获取更多积点哦~</div>
          <div class="succ-modal-footer">
            <gj-button class="cancelBtn" @click="cancel">下次再说</gj-button>
            <gj-button type="primary" @click="taskList">任务列表</gj-button>
          </div>
        </div>
      </div>
    </template>
  </gj-modal>
</template>

<script>
import {SET_USER_GUIDE_STATE} from "@/store/mutation-types";
import {modalMixIn, userGuideMixin} from "@/minxins";
import {mapGetters} from "vuex";
import NoviceGuide from '@/views/modules/home/novice-guide/novice-guide'
export default {
  name: "app-user-guide-succ",
  mixins: [modalMixIn, userGuideMixin],
  props: {
    id: {
      require: true,
    }
  },
  data() {
    return {
      integral: 0,
      taskName: ''
    }
  },
  created() {
    const { index, task } = this.getTaskInfo(this.id)
    this.integral = task.taskPoints;
    this.taskName =  `任务${this.indexTransform(index)}：${task.taskTypeName}`;
  },
  methods: {
    cancel() {
      this.$store.commit(SET_USER_GUIDE_STATE, false);
      this.$gjDestroy()
    },
    taskList() {
      this.openNoviceGuide()
      this.$store.commit(SET_USER_GUIDE_STATE, false);
      this.$gjDestroy()
      // 打开任务列表
      // this.$gjCreate

    },
       //打开新手指引
    openNoviceGuide() {
      this.$gjCreate(NoviceGuide,{global: true})
    },
    // 序号转换
    indexTransform(index) {
      let text = ''
      switch (index) {
        case 1:
          text = '一'
          break;
        case 2:
          text = '二'
          break
        case 3:
          text = '三'
          break
        case 4:
          text = '四'
          break
        case 5:
          text = '五'
          break
        case 6:
          text = '六'
          break
      }
      return text
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-dialog__body {
  padding: 0;
}
.user-guide-succ-container {
  width: 400px;
  height: 334px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.24);
  border-radius: 4px;
  .succ-modal-top {
    width: 100%;
    height: 150px;
    background: #FFF8ED;
    background-image: url("~@/assets/images/userGuide/succBg.png");
    background-repeat: no-repeat;
    background-position: center 70%;
    background-size: 188px 78px;
    border-radius: 4px;
    position: relative;
    .succ-icon {
      width: 106px;
      height: 100px;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-top: -50px;
      margin-left: -53px;
    }
  }
  .succ-modal-main {
    .succ-modal-title {
      font-weight: 600;
      font-size: 14px;
      color: #333333;
      margin-top: 25px;
    }
    .succ-modal-integral {
      font-weight: 600;
      font-size: 12px;
      color: #ED6A0C;
      margin-top: 10px;
    }
    .succ-modal-tip {
      font-size: 12px;
      color: #666666;
      margin-top: 15px;
    }
    .succ-modal-footer {
      margin-top: 24px;
      .cancelBtn {
        border: 1px solid #4994FC;
        border-radius: 2px;
        color: #1F6EEF;
      }
    }
  }
}
</style>